<template>
  <div class="full-height">
    <crud-layout
      ref="crudLayout"
      :name="name"
      :interface="nmInterface"
      :id="id"
      :page="page"
      :page-detail="detailPage"
      :page-table="pageTable"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import ConsentLetterPage from './ConsentLetterPage'
import ConsentLetterDetailPage from './ConsentLetterDetailPage'
import ConsentLetterPageTable from './ConsentLetterPageTable'
import { repository } from 'jtech'
import ConsentLetterModel from './ConsentLetterModel'
const CrudLayout = JtCrud.CrudLayout

@Component({
  name: 'ConsentLetter',
  components: { CrudLayout, ConsentLetterPage, ConsentLetterDetailPage, ConsentLetterPageTable },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ConsentLetter extends Vue {
  state = ConsentLetterModel.getInstance()
  async btGravar ({ button, params, page, controller }) {
    this.associateTechinicalAssessmentWhenExist(params)
    await repository.create(button.action, params)
    page.limparForm()

    const dados = await repository.resolveLogic('consentLetter.clearForm', params)

    page.$refs.dynamicForm.model.register = dados.register
    page.$refs.dynamicForm.model.startDate = dados.startDate
    page.$refs.dynamicForm.model.endDate = ''
    this.$emit('closeConsentLetterModal')
  }

  associateTechinicalAssessmentWhenExist (params) {
    if (!this.isObjectEmpty(this.state.techinicalAssessmentId)) {
      params.techinicalAssessmentId = this.state.techinicalAssessmentId
    }
  }

  isObjectEmpty (object) {
    return object !== null && typeof object === 'object' && Object.keys(object).length === 0
  }

  async btSendEmailConsentLetterPdf ({ button, params, page, controller }) {
    await repository.resolveLogic('consentLetter.sendEmailConsentLetterPdf', params)
  }

  mounted () {
    try {
      this.$refs.crudLayout.onButton('btGravar', this.btGravar)
      this.$refs.crudLayout.onButton('btSendEmailConsentLetterPdf', this.btSendEmailConsentLetterPdf)
    } catch (error) {

    }
  }

  get nmInterface () {
    return this.interface
  }

  get page () {
    return ConsentLetterPage
  }

  get detailPage () {
    return ConsentLetterDetailPage
  }

  get pageTable () {
    return ConsentLetterPageTable
  }
}
export default ConsentLetter
</script>
<style lang="stylus" scoped>
</style>
